import styled from 'styled-components';

export const Main = styled.main`
  width: 100%;
  min-height: 80vh;
`;

export const Section = styled.section`
  width: 100%;
`;

export const Container = styled.div`
  margin: 0 auto;
  max-width: 100%;
  padding: 0 15px;
  width: 1200px;
`;
